export default {
    data () {
        return {
            responsive: false
        }
    },
    mounted () {
        this.onResponsiveInverted()
        window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResponsiveInverted)
    },
    methods:{     
        onResponsiveInverted () {
            this.responsive = (window.innerWidth < 991);
        }          
    },        
}